import script from "./form-user.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-user.vue?vue&type=script&setup=true&lang=ts"

import "./form-user.vue?vue&type=style&index=0&id=7a6d1ce5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6d1ce5"]])

export default __exports__